import * as I from "../../lib/Icons/WhiteboardIcons";

export const CATEGORIES = [
  { id: "standard",   label: "Standard"   },
  { id: "frameworks", label: "Frameworks" },
  { id: "charts",     label: "Charts"     },
  { id: "media",      label: "Media"      },
];

const t = (id, label, Icon, extra = {}) => ({ kind: "tool", id, label, Icon, ...extra });
const a = (id, label, Icon, extra = {}) => ({ kind: "action", id, label, Icon, ...extra });
const f = (id, label, Icon) => ({ kind: "framework", id, label, Icon, showLabel: true });

export const TOOLBAR = {
  standard: [
    [t("eraser", "Eraser", I.IconEraser, { hint: "E" })],
    [{ kind: "colors" }],
    [t("pen", "Pen", I.IconPen, {
      hint: "P",
      flyout: [t("highlighter", "Highlighter", I.IconHighlighter, { hint: "L" })],
    })],
    [t("text", "Text", I.IconText, { hint: "T" })],
    [t("rect", "Rectangle", I.IconSquare, {
      hint: "R",
      flyout: [
        t("circle", "Circle", I.IconCircle, { hint: "C" }),
        t("triangle", "Triangle", I.IconTriangle, { hint: "G" }),
      ],
    })],
    [t("line", "Line", I.IconLine, {
      hint: "N",
      flyout: [t("arrow", "Arrow", I.IconArrow, { hint: "A" })],
    })],
    [{ kind: "size" }],
    [
      a("image-upload", "Upload image", I.IconImageUpload),
      a("grid", "Toggle grid", I.IconGrid),
    ],
    [
      a("zoom-in", "Zoom in", I.IconZoomIn, {
        flyout: [a("zoom-out", "Zoom out", I.IconZoomOut)],
      }),
      t("crop", "Crop", I.IconCrop),
    ],
    [
      t("artboard", "Artboard", I.IconFrame),
      a("export", "Export", I.IconImageUpload),
    ],
  ],

  frameworks: [
    [f("brief", "Brief", I.IconBrief)],
    [f("smart", "SMART", I.IconSmart)],
    [f("swot", "SWOT", I.IconSwot)],
    [f("pros-cons", "Pros/Cons", I.IconProsCons)],
    [f("mindmap", "Mind Map", I.IconMindMap)],
    [f("affinity", "Affinity", I.IconAffinity)],
    [f("fishbone", "Fishbone", I.IconFishbone)],
    [f("5why", "5 Whys", I.IconFiveWhys)],
    [f("kanban", "Kanban", I.IconKanban)],
  ],

  charts: [
    [t("chart-bar", "Bar chart", I.IconBarChart, {
      flyout: [
        t("chart-column", "Column", I.IconBarChart),
        t("chart-stacked", "Stacked", I.IconBarChart),
      ],
    })],
    [t("chart-line", "Line chart", I.IconLineChart, {
      flyout: [t("chart-area", "Area", I.IconLineChart)],
    })],
    [t("chart-pie", "Pie chart", I.IconPieChart, {
      flyout: [t("chart-donut", "Donut", I.IconPieChart)],
    })],
    [t("chart-table", "Table", I.IconTable)],
    [t("chart-timeline", "Timeline", I.IconTimeline)],
    [a("chart-data", "Edit values", I.IconEditData)],
  ],

  media: [
    [t("gpt-image", "GPT Image", I.IconSparkle, { showLabel: true })],
    [t("sticker", "Sticker", I.IconSticker)],
    [t("sticky", "Sticky note", I.IconStickyNote)],
    [t("frame", "Frame", I.IconFrame)],
    [t("tape", "Tape", I.IconTape)],
    [t("emoji", "Emoji", I.IconEmoji)],
    [t("connector", "Connector", I.IconConnector, {
      flyout: [t("connector-arrow", "Connector arrow", I.IconArrow)],
    })],
    [a("unsplash", "Reference images", I.IconVisionBoard, { showLabel: true })],
    [a("image-upload", "Upload image", I.IconImageUpload)],
  ],
};

export const DRAW_TOOLS = ["pen", "highlighter", "eraser"];
export const SHAPE_TOOLS = ["rect", "circle", "triangle"];
export const LINE_TOOLS = ["line", "arrow"];
export const STAMP_TOOLS = ["sticky", "sticker", "tape", "frame", "emoji"];

export const CONNECTOR_TOOLS = ["connector", "connector-arrow"];

export const IMAGE_SLOT_TOOL = "gpt-image";

export const CHART_TOOLS = {
  "chart-bar": "bar",
  "chart-column": "column",
  "chart-stacked": "stacked",
  "chart-line": "line",
  "chart-area": "area",
  "chart-pie": "pie",
  "chart-donut": "donut",
  "chart-table": "table",
  "chart-timeline": "timeline",
};

export const KEY_TO_TOOL = {
  v: "select", h: "hand", p: "pen", l: "highlighter", e: "eraser",
  t: "text", r: "rect", c: "circle", g: "triangle", n: "line", a: "arrow",
};

export const SHARED_TOP = [
  [t("select", "Select", I.IconSelect, { hint: "V" }), t("hand", "Pan", I.IconHand, { hint: "H" })],
];

export const SHARED_BOTTOM = [
  [a("undo", "Undo", I.IconUndo), a("redo", "Redo", I.IconRedo)],
  [a("clear", "Clear board", I.IconClose, { danger: true })],
];

export const STICKER_GLYPHS = ["\u2B50", "\u2705", "\u274C", "\u2757", "\u2753", "\u2764\uFE0F", "\u26A1", "\uD83D\uDD25", "\uD83D\uDC4D", "\uD83D\uDCA1", "\uD83D\uDCCC", "\uD83C\uDFAF"];
export const EMOJI_GLYPHS = ["😀", "😅", "🤔", "🙌", "🎉", "😴", "😬", "🤯", "👀", "✅", "⚠️", "🚀"];
